import axiosInstance from '../axiosInstance';

const BASE_URL = '/report/manifests-tracking';

export const fetchManifestTrackingSummary = async (params = {}) => {
    const { data } = await axiosInstance.get(`${BASE_URL}/summary`, { params });
    return data;
};

export const fetchManifestsTracking = async (params = {}) => {
    const { data } = await axiosInstance.get(BASE_URL, { params });
    return data;
};

export const fetchManifestTrackingDetail = async (manID) => {
    const { data } = await axiosInstance.get(`${BASE_URL}/${manID}`);
    return data;
};

export const fetchManifestTrackingCatalogs = async () => {
    const { data } = await axiosInstance.get(`${BASE_URL}/catalogs`);
    return data;
};